import { Dispatcher } from "flux"

/* eslint import/no-anonymous-default-export: [2, {"allowNew": true}] */
export default new Dispatcher()
